import useBrainSearchBot from "@/admin/integrations/chat-bot/util/useBrainSearchBot"
import ArrowLeftIcon from "@/core/ui/iconsax/linear/arrow-left.svg"
import { DrawerReturnDestination } from "@/core/context/GlobalDrawerProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoIconButton } from "@disco-ui"
import useFeatureFlags from "@utils/hook/useFeatureFlags"
import { TestIDProps } from "@utils/typeUtils"
import { useQueryParams } from "@utils/url/urlUtils"
import { useHistory } from "react-router-dom"

type Props = TestIDProps

function DrawerReturnButton({ testid = "DrawerReturnButton" }: Props) {
  const { brainSearch } = useFeatureFlags()
  const brainSearchBot = useBrainSearchBot()
  const history = useHistory()
  const classes = useStyles()
  const { return: returnParam } = useQueryParams<{ return?: DrawerReturnDestination }>()

  // Get tooltip text based on return parameter
  const getTooltipText = () => {
    switch (returnParam) {
      case "ask":
        return `Back to ${brainSearchBot?.name || "Ask AI"}`
      default:
        return "Back"
    }
  }

  // Check if we should show the button based on return parameter
  const shouldShow = () => {
    switch (returnParam) {
      case "ask":
        return brainSearch && brainSearchBot?.status === "active"
      default:
        return false
    }
  }

  if (!returnParam || !shouldShow()) return null

  return (
    <DiscoIconButton
      testid={testid}
      tooltip={getTooltipText()}
      width={40}
      height={40}
      className={classes.backButton}
      onClick={handleReturn}
    >
      <ArrowLeftIcon width={20} height={20} />
    </DiscoIconButton>
  )

  function handleReturn() {
    history.goBack()
  }
}

const useStyles = makeUseStyles((theme) => ({
  backButton: {
    padding: theme.spacing(1.25),
    borderRadius: theme.measure.borderRadius.medium,
    "& svg": {
      color: theme.palette.groovy.neutral[700],
    },
  },
}))

export default DrawerReturnButton
